import angular from "angular";
import _ from "lodash";
import htmlTemplate from "./wbs_editor.html";
import WBSEditor from "./wbseditor/WBSEditor";
import { toggleStructureOverlayForNodeTap } from "./wbs_overlay_navigation.helper";
import "common/errors/PresentableError";
import "common/errors/RequestError";
import "../services/wbs/wbs_api.service";
import "common/services/services";

export default angular
    .module("sbApp.wbs", ["sbApp.wbsApiService", "sbApp.services"])
    .directive("sbWbsEditor", function WbsEditorDirective() {
        return {
            restrict: "E",
            templateUrl: htmlTemplate,
            controllerAs: "wbsEditor",
            bindToController: {
                projectId: "=",
            },
            controller: function WbsEditorCtrl(
                $rootScope,
                $q,
                $element,
                $sbErrorPresenter,
                $translate,
                wbsApiService,
                $mdDialog,
                $filter,
                $sbDetailsOverlay,
                $sbExternalService
            ) {
                var vm = this;

                vm.$onInit = onInit;
                vm.$onDestroy = onDestroy;

                vm.createStructureEditor = createStructureEditor;
                vm.changeStructure = changeStructure;
                vm.reloadWbsEditor = reloadWbsEditor;

                var unWatch = $rootScope.$on(
                    "$translateChangeSuccess",
                    updateTranslation
                );
                var naturalSort = $filter("naturalSort");
                var structureNodeTapListener;
                var structuresSubscription;

                function onInit() {
                    vm.editor = vm.createStructureEditor(
                        $element[0].querySelector("canvas")
                    );
                    structureNodeTapListener = vm.editor.stage.on(
                        "structureNodeTap",
                        onStructureNodeTap
                    );
                    structuresSubscription = $sbExternalService
                        .structuresService()
                        ?.structures$.subscribe(function (structures) {
                            syncEditedStructures(vm.editor, structures);
                        });
                    updateTranslation(vm.editor); // set once -> i18n can not be changed without reload

                    return reloadWbsEditor(vm.editor);
                }

                function onDestroy() {
                    vm.editor.stage.off(
                        "structureNodeTap",
                        structureNodeTapListener
                    );
                    vm.editor.keyboardhandler.detachHandler();
                    structuresSubscription?.unsubscribe();
                    unWatch();
                }

                function onStructureNodeTap(event) {
                    toggleStructureOverlayForNodeTap(event, $sbDetailsOverlay);
                }

                function updateTranslation(editor) {
                    var i18nKeys = [
                        "WBS_CREATE_CHILD_TOOLTIP",
                        "WBS_CREATE_SIBLING_TOOLTIP",
                        "WBS_DELETE_NODE_TOOLTIP",
                    ];
                    var translations = $translate.instant(i18nKeys);

                    editor.setI18n({
                        CREATE_CHILD_TOOLTIP:
                            translations.WBS_CREATE_CHILD_TOOLTIP,
                        CREATE_SIBLING_TOOLTIP:
                            translations.WBS_CREATE_SIBLING_TOOLTIP,
                        DELETE_NODE_TOOLTIP:
                            translations.WBS_DELETE_NODE_TOOLTIP,
                    });
                    return editor;
                }

                function reloadWbsEditor(editor) {
                    return loadStructure()
                        .then(function (treeModel) {
                            _sortTreeNaturally(treeModel.components);
                            editor.enableEditorMode();
                            editor.setTreeModel(treeModel);
                            return treeModel;
                        })
                        .catch($sbErrorPresenter.catch);
                }

                function _sortTreeNaturally(components) {
                    _sortNaturallyByCode(components);

                    _.forEach(components, function (component) {
                        if (component.components) {
                            _sortTreeNaturally(component.components);
                        }
                    });
                }

                function _sortNaturallyByCode(components) {
                    return naturalSort(components, "CODE");
                }

                function loadStructure() {
                    return wbsApiService.loadTree(vm.projectId);
                }

                function createStructureEditor(canvas) {
                    return new WBSEditor(
                        canvas,
                        $sbErrorPresenter,
                        wbsApiService,
                        false,
                        $mdDialog
                    );
                }

                // names/codes can be edited from the structure overlay
                //
                function syncEditedStructures(editor, structures) {
                    var nodeManager = editor.nodeManager;
                    var stage = editor.stage;

                    structures.forEach(function (structure) {
                        var data = nodeManager.getData(structure.id);
                        if (!data) {
                            return;
                        }
                        if (data.CODE !== structure.code) {
                            nodeManager.changeProperty(
                                structure.id,
                                "CODE",
                                structure.code
                            );
                        }
                        if (data.NAME !== structure.name) {
                            nodeManager.changeProperty(
                                structure.id,
                                "NAME",
                                structure.name
                            );
                        }
                    });

                    stage.setNeedsDisplay();
                }

                function changeStructure(editor, idToCodeMap) {
                    var stage = editor.stage,
                        nodeManager = editor.nodeManager;

                    Object.keys(idToCodeMap).forEach(function (id) {
                        nodeManager.changeProperty(id, "CODE", idToCodeMap[id]);
                    });

                    stage.setNeedsDisplay();
                }
            },
            link: function link($scope, $element, $attr, ctrl) {
                // trigger reload of editor after merge
                //
                $scope.$on("reloadEditor", function () {
                    ctrl.reloadWbsEditor(ctrl.editor);
                });

                // listen to changed codes from auto-generation process
                //
                $scope.$on("codeChanged", function ($event, idToCodeMap) {
                    ctrl.changeStructure(ctrl.editor, idToCodeMap);
                });
            },
        };
    });
